import React from 'react';
// import DraggableTodoList from 'components/General/Task/components/DraggableList';
import TaskListModalView from 'components/General/Task/Views/TaskList/ModalView';

export default function Tasks({ activeList, title = 'Yapılacaklar' }) {
    return <TaskListModalView taskListID={activeList} taskID={null} title={title} />;
}
